import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { getObjectsSum } from '../../../utils/common'
import { CHART_ANCHORED_TOOLTIP_PROPS, ChartArea } from '../../Chart'
import Text from '../../Text'
import {
  BIRDVIEW_CHART_DATE_KEY,
  BIRDVIEW_CHART_FLOW_CLOSED_KEY,
  BIRDVIEW_CHART_FLOW_OPENED_KEY,
  BIRDVIEW_TREND_GLYPH,
} from '../DashboardBirdview.constants.charts'
import { getBirdviewTrend } from '../DashboardBirdview.utils.charts'

import { BirdviewFlowTooltip } from './BirdviewFlowTooltip'
import {
  BIRDVIEW_FLOW_CHART_GRID_PROPS,
  BIRDVIEW_FLOW_TREND_HEADLINE_KEY,
} from './BirdviewLineChart.constants'
import {
  getBirdviewFlowSeries,
  getBirdviewLineChartXAxisProps,
} from './BirdviewLineChart.utils'

import * as styles from './BirdviewLineChart.module.css'

function BirdviewLineChart({ points }) {
  const { t } = useTranslation()

  const opened = getObjectsSum(points, BIRDVIEW_CHART_FLOW_OPENED_KEY)
  const closed = getObjectsSum(points, BIRDVIEW_CHART_FLOW_CLOSED_KEY)
  const delta = opened - closed
  const trend = getBirdviewTrend(delta)

  return (
    <>
      <div className={styles.verdict}>
        <span className={classNames(styles.icon, styles[trend])}>
          {BIRDVIEW_TREND_GLYPH[trend]}
        </span>
        <span className={styles.text}>
          <Text className={styles.headline}>
            {t(BIRDVIEW_FLOW_TREND_HEADLINE_KEY[trend], { count: delta })}
          </Text>
          <Text className={styles.totals}>
            {t('DashboardBirdview.ChartFlowTotalsKey', { closed, opened })}
          </Text>
        </span>
      </div>
      <div className={styles.chart}>
        <ChartArea
          data={points}
          gridProps={BIRDVIEW_FLOW_CHART_GRID_PROPS}
          nameKey={BIRDVIEW_CHART_DATE_KEY}
          series={getBirdviewFlowSeries(t)}
          tooltipProps={{
            ...CHART_ANCHORED_TOOLTIP_PROPS,
            content: <BirdviewFlowTooltip />,
          }}
          xAxisProps={getBirdviewLineChartXAxisProps()}
        />
      </div>
    </>
  )
}

export default BirdviewLineChart
